export const ATTRIBUTES_LABELS = {
  ean_grp: 'EAN',
  dun_grp: 'DUN',
  peso_grp: 'Peso',
  grp_marca: 'Marca',
  familia_grp: 'Família',
  dimensao_grp: 'Dimensão',
  fabricante_401: 'Fabricante',
  volume_104: 'Volume',
  palavra_chave_grp: 'Palavra-chave',
  description: 'Especificação detalhada',
  cod_promocao: 'Cód. Promoção',
  formato_101: 'Formato',
  fragrância_201: 'Fragrância',
  tipo_81: 'Tipo',
  embalagem_105: 'Embalagem',
  MD_ALTURA: 'Altura',
  MD_LARGURA: 'Largura',
  MD_PROFUNDIDADE: 'Profundidade',
  MD_CUBAGEM: 'Cubagem',
  QTD_CX_CAMADA: 'Qtd. Caixa/Camada',
  QTD_CX_PALETE: 'Qtd. Caixa/Palete',
  MD_PESO_LIQUIDO: 'Peso Líquido',
  MD_PESO_BRUTO: 'Peso Bruto',
}